import { useTranslation } from 'react-i18next'

interface ConfirmDialogProps {
  title: string
  message: string
  onConfirm: () => void
  onCancel: () => void
  confirmText?: string
  cancelText?: string
}

const ConfirmDialog = ({ title, message, onConfirm, onCancel, confirmText, cancelText }: ConfirmDialogProps) => {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
      <div className="bg-white dark:bg-zinc-950 border border-gray-200 dark:border-zinc-800 rounded-lg shadow-lg p-6 max-w-sm mx-4 animate-in fade-in zoom-in-95">
        <div className="space-y-4">
          <div className="space-y-2">
            <h2 className="text-lg font-semibold leading-none tracking-tight text-gray-900 dark:text-white">{title}</h2>
            <p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>
          </div>

          <div className="flex gap-2 justify-end pt-2">
            <button
              onClick={onCancel}
              className="rounded-md text-sm font-medium px-4 py-2 border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-zinc-700 transition-colors"
            >
              {cancelText || t('common.cancel', 'Cancel')}
            </button>
            <button
              data-testid="dialog-confirmation-button"
              onClick={onConfirm}
              className="rounded-md text-sm font-medium px-4 py-2 bg-red-600 text-white hover:bg-red-700 transition-colors"
            >
              {confirmText || t('common.confirm', 'Confirm')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
